import { Component, OnInit } from "@angular/core";
import { ApiService } from "src/app/shared/services/api.service";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
})
export class DashboardComponent implements OnInit {

  dashboardData: any;

  constructor(private apiService: ApiService) {}

  ngOnInit() {
    // this.getRole();
    this.getDashboardData();
  }

  getRole() {
    this.apiService.apiCall('get', '/api/SiteDoctors/GetDoctorRole', {}).subscribe((res: any) => {
      console.log(res);
    })
  }

  getDashboardData() {
    this.apiService.apiCall('post', '/api/User/AdminDashboard', {}).subscribe((res: any) => {
      console.log(res);
      this.dashboardData = res.body.model;
    })
  }
}
